type ReturnType = {
  gaExactMatch?: string
  gscExactMatch?: string
  hasGaAccess: boolean
  hasGscAccess: boolean
}

type Option = {
  label: {
    header: string
    subHeader?: string
  }
  value: string
}

export const getAutoMatchProperties = ({
  domain,
  gaProperties,
  gscProperties,
}: {
  domain: string
  gaProperties?: Option[]
  gscProperties?: Option[]
}): ReturnType => {
  const regex = /https:\/\/|www\./

  const gaMatch = gaProperties?.find(
    gaItem =>
      gaItem.label.header?.replace(regex, '') === domain.replace(regex, '')
  )

  const isGaExactMatch = gaMatch?.label?.header === domain

  const gscMatch = gscProperties?.find(
    gscItem =>
      gscItem.label.header?.replace(regex, '') === domain.replace(regex, '')
  )

  const isGscExactMatch = gscMatch?.label?.header === domain

  return {
    gaExactMatch: isGaExactMatch ? gaMatch.value : undefined,
    gscExactMatch: isGscExactMatch ? gscMatch.value : undefined,
    hasGaAccess: !!gaProperties?.length,
    hasGscAccess: !!gscProperties?.length,
  }
}
